import {
  Component,
  OnInit,
  Inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { BaseConfirmComponent } from '../base-confirm.component';

@Component({
  selector: 'lss-simple-confirm',
  template: `
    <div class="input-block">
      <h1 class="title">{{ header }}</h1>
      <div class="body">{{ body }}</div>
    </div>
    <div class="modal-buttons">
      <lss-button (action)="decline()" [color]="'secondary'">
        <span>
          {{ declineButtonText }}
        </span>
      </lss-button>
      <lss-button (action)="accept()">
        <span>
          {{ confirmButtonText }}
        </span>
      </lss-button>
    </div>
  `,
  styleUrls: ['./simple-confirm.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleConfirmComponent
  extends BaseConfirmComponent
  implements OnInit
{
  constructor(
    protected modalRef: MatDialogRef<SimpleConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) protected data: any,
  ) {
    super(modalRef, data);
  }

  ngOnInit(): void {
    this.confirmButtonText = this.confirmButtonText ?? 'Confirm';
    this.declineButtonText = this.declineButtonText ?? 'Cancel';
  }
}
